module.exports = {
  entry: './src/apps/data-breach-bars/index.tsx',
  shortcode: 'data-breach-bars',
  title: 'Data Breach Bars',
  status: 'stable',
  description: 'Widget for Cost of Data Breach 2022 - Bars chart',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-data-breach-bars-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/reports'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
